import { Switch } from "@maysoft/common-component-react"
import { Typography, Stack, Paper } from "@mui/material"
import { useEffect, useState } from "react"

// 👇 config field
const NOTIFICATION_FIELDS = [
    { key: "course", label: "Course" },
    { key: "post", label: "Post" }
] as const

type PublishKey = (typeof NOTIFICATION_FIELDS)[number]["key"]

type SettingType = {
    publishNotification: Record<PublishKey, number>
}

type Props = {
    value: string
    onChange: (val: string) => void
}

const DEFAULT_VALUE: SettingType = {
    publishNotification: {
        course: 0,
        post: 0
    }
}

const NotificationConfigForm = ({
    value,
    onChange
}: Props) => {
    const [settingValue, setSettingValue] = useState<SettingType>(DEFAULT_VALUE)

    useEffect(() => {
        try {
            const parsed = JSON.parse(value || "{}")

            setSettingValue({
                ...DEFAULT_VALUE,
                ...parsed,
                publishNotification: {
                    ...DEFAULT_VALUE.publishNotification,
                    ...(parsed.publishNotification || {})
                }
            })
        } catch {
            setSettingValue(DEFAULT_VALUE)
        }
    }, [value])

    const handleChange = (key: PublishKey, val: number) => {
        const updated = {
            ...settingValue,
            publishNotification: {
                ...settingValue.publishNotification,
                [key]: val
            }
        }

        setSettingValue(updated)
        onChange(JSON.stringify(updated))
    }

    return (
        <Paper sx={{ p: 2, borderRadius: 2 }}>
            <Stack spacing={2}>
                {NOTIFICATION_FIELDS.map((item) => (
                    <Stack
                        key={item.key}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="subtitle2">
                            {item.label}
                        </Typography>

                        <Switch
                            checked={settingValue.publishNotification[item.key] === 1}
                            onChange={(e) =>
                                handleChange(
                                    item.key,
                                    e.target.checked ? 1 : 0
                                )
                            }
                        />
                    </Stack>
                ))}
            </Stack>
        </Paper>
    )
}

export default NotificationConfigForm